import React from 'react';
import NaturalBackgroundImage from '../img/image10.webp';

const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section style={styles.section} className="hero-section">
      <div style={styles.overlay} className="hero-overlay"></div>
      <div style={styles.container} className="hero-container">
        <div style={styles.content} className="hero-content">
          <h1 style={styles.heading} className="hero-heading">
            Personalized Diet Plans<br />
            for Weight Loss, PCOS,<br />
            Diabetes & More
          </h1>

          <p style={styles.subheading} className="hero-subheading">
            Transform your health with expert dietary guidance tailored to your
            unique needs and lifestyle.
          </p>

          <button
            style={styles.button}
            className="hero-button"
            onClick={scrollToContact}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#00a869';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#00ba76';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Start Your Journey
          </button>
        </div>
      </div>

      {/* Responsive CSS */}
      <style>
        {`
          /* Default - Desktop */
          .hero-section {
            background-position: center !important;
            background-size: cover !important;
          }

          /*
            Gradient overlay: solid/opaque behind the text (left side)
            fading to fully transparent over the photo (right side).
            This keeps text readable while showing the image's real color.
          */
          .hero-overlay {
            background: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.97) 0%,
              rgba(255, 255, 255, 0.94) 35%,
              rgba(255, 255, 255, 0.55) 55%,
              rgba(255, 255, 255, 0.05) 75%,
              rgba(255, 255, 255, 0) 100%
            ) !important;
          }

          /* iPhone SE (375px) */
          @media (max-width: 375px) {
            .hero-section {
              min-height: 800px !important;
              background-size: cover !important;
              background-position: 72% 5% !important;
            }
            .hero-heading {
              font-size: 1.5rem !important;
              line-height: 1.3 !important;
            }
            .hero-subheading {
              font-size: 0.85rem !important;
              padding: 0 5px !important;
            }
            .hero-button {
              font-size: 0.9rem !important;
              padding: 10px 18px !important;
            }
          }

          /* iPhone XR, iPhone 12 Pro (390-430px) */
          @media (min-width: 376px) and (max-width: 430px) {
            .hero-section {
              min-height: 820px !important;
              background-size: cover !important;
              background-position: 70% 5% !important;
            }
            .hero-heading {
              font-size: 1.6rem !important;
            }
          }

          /* iPhone 14 Pro Max (430px) */
          @media (min-width: 431px) and (max-width: 480px) {
            .hero-section {
              min-height: 840px !important;
              background-size: cover !important;
              background-position: 68% 5% !important;
            }
            .hero-heading {
              font-size: 1.7rem !important;
            }
          }

          /* Pixel 7, Samsung Galaxy S8+ (412-420px) */
          @media (min-width: 410px) and (max-width: 420px) {
            .hero-section {
              background-size: cover !important;
              background-position: 69% 5% !important;
            }
          }

          /* Samsung Galaxy S20 Ultra, A51/71 (384-412px) */
          @media (min-width: 380px) and (max-width: 415px) {
            .hero-section {
              background-size: cover !important;
              background-position: 69% 5% !important;
            }
          }

          /* Tablet (iPad Mini, iPad Air) */
          @media (min-width: 768px) and (max-width: 1024px) {
            .hero-section {
              min-height: 550px !important;
              background-position: 60% center !important;
            }
            .hero-heading {
              font-size: 2rem !important;
              text-align: left !important;
            }
            .hero-subheading {
              font-size: 0.95rem !important;
              text-align: left !important;
            }
            .hero-content {
              max-width: 450px !important;
            }
            .hero-container {
              padding: 0 40px !important;
            }
          }

          /* iPad Pro, Surface Pro 7 (1024px - 1366px) */
          @media (min-width: 1025px) and (max-width: 1366px) {
            .hero-section {
              min-height: 700px !important;
              background-position: 55% center !important;
            }
            .hero-heading {
              font-size: 2.4rem !important;
            }
          }

          /* Foldable devices (Galaxy Z Fold 5, Asus Zenbook Fold) */
          @media (min-width: 768px) and (max-height: 700px) {
            .hero-section {
              min-height: 500px !important;
              background-position: 58% center !important;
            }
          }

          /* Surface Duo (540px - 720px) */
          @media (min-width: 540px) and (max-width: 720px) {
            .hero-section {
              min-height: 700px !important;
              background-size: cover !important;
              background-position: 66% 5% !important;
            }
            .hero-heading {
              font-size: 1.9rem !important;
            }
          }

          /* Nest Hub (1024px) */
          @media (min-width: 1024px) and (max-height: 600px) {
            .hero-section {
              min-height: 500px !important;
              background-position: 57% center !important;
            }
          }

          /* Nest Hub Max (1280px) */
          @media (min-width: 1280px) and (max-height: 800px) {
            .hero-section {
              min-height: 600px !important;
            }
          }

          /* Mobile devices landscape */
          @media (max-width: 896px) and (orientation: landscape) {
            .hero-section {
              min-height: 480px !important;
              background-size: cover !important;
              background-position: 66% 5% !important;
            }
            .hero-heading {
              font-size: 1.5rem !important;
              margin-bottom: 10px !important;
            }
            .hero-subheading {
              font-size: 0.8rem !important;
              margin-bottom: 15px !important;
            }
            .hero-content {
              padding-top: 10px !important;
            }
          }

          /* Large desktop screens */
          @media (min-width: 1440px) {
            .hero-section {
              min-height: 850px !important;
              background-position: 45% center !important;
            }
            .hero-heading {
              font-size: 3rem !important;
            }
            .hero-subheading {
              font-size: 1.1rem !important;
            }
          }

          /* Extra large screens */
          @media (min-width: 1920px) {
            .hero-section {
              min-height: 900px !important;
              background-position: 40% center !important;
            }
          }

          /* Common mobile adjustments */
          @media (max-width: 767px) {
            .hero-section {
              background-size: cover !important;
              background-position: 69% 5% !important;
            }
            .hero-heading {
              text-align: left !important;
            }
            .hero-subheading {
              text-align: left !important;
              margin-bottom: 24px !important;
            }
            .hero-content {
              max-width: 88% !important;
              align-items: flex-start !important;
              justify-content: flex-start !important;
              margin: 0 !important;
              padding-top: 32px !important;
            }
            .hero-container {
              padding: 0 20px !important;
              display: flex !important;
              align-items: flex-start !important;
              justify-content: flex-start !important;
            }
            .hero-button {
              align-self: flex-start !important;
            }
            .hero-heading,
            .hero-subheading {
              text-shadow: 0 1px 3px rgba(255, 255, 255, 0.95), 0 2px 10px rgba(255, 255, 255, 0.95), 0 0 20px rgba(255, 255, 255, 0.8) !important;
            }

            /* White wash removed on mobile so the photo shows through fully.
               Legibility now comes from the text-shadow above instead of an
               opaque backing panel. */
            .hero-overlay {
              background: transparent !important;
            }
          }

          /* Small mobile text adjustments */
          @media (max-width: 480px) {
            .hero-heading {
              font-size: 1.6rem !important;
              margin-bottom: 12px !important;
            }
            .hero-subheading {
              font-size: 0.9rem !important;
              margin-bottom: 20px !important;
              padding: 0 10px 0 0 !important;
            }
            .hero-button {
              font-size: 0.95rem !important;
              padding: 10px 20px !important;
            }
          }

          /* For better image display */
          .hero-section {
            background-attachment: scroll !important;
          }

          /* Ensure content is properly centered */
          .hero-container {
            height: 100% !important;
            display: flex !important;
            align-items: center !important;
          }
        `}
      </style>
    </section>
  );
};

const styles = {
  section: {
    position: 'relative',
    minHeight: '750px',
    display: 'flex',
    alignItems: 'center',
    backgroundImage: `url(${NaturalBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
  },

  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // Base (desktop) gradient - overridden by the .hero-overlay CSS rule above,
    // this is just a safe fallback in case the <style> tag hasn't loaded yet.
    background: 'linear-gradient(90deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 35%, rgba(255,255,255,0.4) 55%, rgba(255,255,255,0) 100%)',
    zIndex: 1,
  },

  container: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 40px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  content: {
    maxWidth: '550px',
    display: 'flex',
    flexDirection: 'column',
  },

  heading: {
    fontSize: '2.6rem',
    fontWeight: '700',
    color: '#1a1a1a',
    lineHeight: '1.25',
    marginBottom: '16px',
    letterSpacing: '-0.01em',
  },

  subheading: {
    fontSize: '1rem',
    color: '#4a5568',
    lineHeight: '1.55',
    marginBottom: '28px',
  },

  button: {
    backgroundColor: '#00ba76',
    color: '#ffffff',
    fontSize: '1.05rem',
    fontWeight: '600',
    padding: '14px 28px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(0, 186, 118, 0.3)',
    alignSelf: 'flex-start',
  },
};

export default HeroSection;
